import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://2a88f3d6420b5fb1f06ae949720045bc@o4504673774141440.ingest.us.sentry.io/4506863537160192",
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
